<template>
  <a
    class="tool hide_non_active_on_mobile"
    data-placement="bottom"
    :data-tip="module.title"
    :class="{ active: activeId === module.id }"
  >
    <template v-if="module.progress && module.progress.length > 0">
      <span class="material-icons" style="text-align: center;">check</span>
      <div
        style="
                    bottom: 37px;
                    display: inline;
                    position: absolute;
                    text-align: center;
                    color:#fff;
                    font-size: 13px;
                    line-height: 14px;"
      >
        <span class="badge badge-primary">completed</span>
      </div>
    </template>
    <template v-else>
      <span class="material-icons" style="margin-left:15px;">descriptions</span>
      <div
        style="
                    bottom: 37px;
                    display: inline;
                    position: absolute;
                    text-align: center;
                    color:#fff;
                    font-size: 13px;
                    line-height: 14px;"
      >
        <span class="badge badge-light">pending</span>
      </div>
    </template>
    <div
      style="
                    top: 37px;
                    display: inline;
                    position: absolute;
                    text-align: center;
                    color:#fff;
                    font-size: 13px;
                    line-height: 14px;"
    >{{module.title}}</div>
  </a>
</template>

<script>
export default {
  name: "ModuleItem",
  props: {
    module: {
      type: Object,
      default() {
        return {};
      }
    },
    activeId: {
      type: Number,
      default() {
        return 2;
      }
    }
  },
  data() {
    return {
      isActive: false
    };
  }
};
</script>

<style lang="scss" scoped>
@media (min-width: 320px) and (max-width: 767px) {
  .hide_non_active_on_mobile {
    display: none;
  }
  .active {
    display: flex;
  }
}
.assessment__item {
  &.active {
    background: $green !important;
    color: $white;
    .assessment-icon {
      border-color: $white !important;
    }
  }
  .assessment-icon {
    top: 45%;
  }
}
</style>
